import React, { useEffect, useState } from 'react';
import { ANIMAL_ICONS, EMPIRE_ICON, TRY_ICON } from '../theme';

/* True while an Aura Codex alarm is ringing (CodexAlarmWatcher broadcasts 'codex-alarm'). */
const useAlarmRinging = () => {
  const [on, setOn] = useState(() => { try { return !!localStorage.getItem('codex_alarm_active'); } catch { return false; } });
  useEffect(() => {
    const h = (e) => setOn(e.detail?.phase === 'start');
    window.addEventListener('codex-alarm', h);
    return () => window.removeEventListener('codex-alarm', h);
  }, []);
  return on;
};

export const BottomNav = ({ activeTab, onTabChange, tryNotifCount = 0 }) => {
  const alarmOn = useAlarmRinging();
  const tabs = [
    { id: 'empire', label: 'Empire', icon: EMPIRE_ICON, isEmpire: true },
    { id: 'fashion', label: 'Fashion', icon: ANIMAL_ICONS.fashion },
    { id: 'food', label: 'Taste', icon: ANIMAL_ICONS.food },
    { id: 'explore', label: 'Explore', icon: ANIMAL_ICONS.explore },
    { id: 'souls', label: 'Soul', icon: ANIMAL_ICONS.souls },
    { id: 'sporty', label: 'Sport', icon: ANIMAL_ICONS.sporty },
    { id: 'success', label: 'Success', icon: ANIMAL_ICONS.success },
    { id: 'legacy', label: 'Legacy', icon: ANIMAL_ICONS.legacy },
    { id: 'art', label: 'Art', icon: ANIMAL_ICONS.art },
    { id: 'try', label: 'Inscribe', icon: TRY_ICON, isTry: true },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 40,
        background: 'rgba(5,5,10,0.80)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        borderTop: '1px solid rgba(212,175,55,0.15)',
      }}
    >
      <style>{`
        @keyframes eggFlicker {
          0%, 100% { filter: brightness(0.9); }
          50% { filter: brightness(1.25); }
        }
        @keyframes eggAlarm {
          0%, 100% { filter: brightness(0.8); box-shadow: 0 0 0 rgba(212,175,55,0); transform: scale(1); }
          50% { filter: brightness(1.6); box-shadow: 0 0 16px rgba(212,175,55,0.95), 0 0 28px rgba(185,120,255,0.6); transform: scale(1.12); }
        }
      `}</style>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '10px 4px 0 4px',
        paddingBottom: 'calc(max(var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)), 28px) + 12px)',
        maxWidth: 600, margin: '0 auto',
      }}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const showDot = tab.id === 'try' && tryNotifCount > 0;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              data-testid={`nav-${tab.id}-tab`}
              data-alarm={tab.isTry && alarmOn ? 'on' : undefined}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '4px',
                flex: 1,
                minWidth: 0,
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                WebkitTapHighlightColor: 'transparent',
                position: 'relative',
              }}
            >
              <div style={{ position: 'relative' }}>
                {/* Golden ring — only on active tab, positioned around the icon */}
                {isActive && (
                  <div style={{
                    position: 'absolute',
                    top: '-4px',
                    left: '-4px',
                    right: '-4px',
                    bottom: '-4px',
                    borderRadius: '50%',
                    border: '2px solid rgba(212,175,55,0.75)',
                    boxShadow: '0 0 10px rgba(212,175,55,0.4)',
                    pointerEvents: 'none',
                  }} />
                )}
                <div
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    ...(tab.isTry && alarmOn ? { outline: '2px solid rgba(212,175,55,0.9)' } : {}),
                    border: isActive ? 'none' : '1px solid rgba(255,255,255,0.08)',
                    boxShadow: isActive ? '0 0 8px rgba(212,175,55,0.3)' : 'none',
                    animation: (tab.isTry && alarmOn) ? 'eggAlarm 0.9s ease-in-out infinite' : (tab.isTry && tryNotifCount > 0) ? 'eggFlicker 2.5s ease-in-out infinite' : 'none',
                  }}
                >
                  <img
                    src={tab.icon.src}
                    alt={tab.label}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: tab.icon.pos, display: 'block' }}
                    loading="lazy"
                  />
                </div>
                {showDot && (
                  <span
                    data-testid="try-notification-dot"
                    style={{
                      position: 'absolute',
                      top: '-2px',
                      right: '-3px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: '#D4AF37',
                      border: '1px solid black',
                    }}
                  />
                )}
              </div>
              <span style={{
                fontFamily: 'Outfit, sans-serif',
                fontSize: '10px',
                lineHeight: 1,
                letterSpacing: '0.03em',
                color: isActive ? '#D4AF37' : 'rgba(255,255,255,0.45)',
                fontWeight: isActive ? 600 : 400,
              }}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
